export enum VatTypeEnum {
  S = 'S',
  R = 'R',
  MR = 'MR',
  E = 'E',
  Z = 'Z',
  SR = 'SR',
  P = 'P',
}
